export const setActiveFeature = activeFeature => {
    return {
        type: "ACTIVE_FEATURE:SET",
        payload: activeFeature,
    };
};
export const setUiSettings = uiSettings => ({
    type: "UI_SETTINGS: SET",
    payload: uiSettings,
});
export const setSearchBarVisible = isVisible => ({
    type: "SEARCH_BAR_VISIBLE:SET",
    payload: isVisible,
});
export const setSearchedLocation = latLng => ({
    type: "SEARCHED_LOCATION:SET",
    payload: latLng,
});
export const setActiveProject = fund => ({
    type: "ACTIVE_PROJECT:SET",
    payload: fund,
});
export const setActiveFilter = fund => ({
    type: "ACTIVE_FILTER:SET",
    payload: fund,
});
export const initActiveFilters = filterArray => ({
    type: "ACTIVE_FILTER:INIT",
    payload: filterArray,
});
export const setBasemap = imagery => ({
    type: "MAP:SET_BASEMAP",
    payload: imagery,
});
export const setActivePage = page => ({
    type: "ACTIVE_PAGE:SET",
    payload: page,
});
export const setMapType = mapType => ({
    type: "MAP_TYPE:SET",
    payload: mapType,
});
export const setIsMultiple = isMultiple => ({
    type: "IS_MULTIPLE:SET",
    payload: isMultiple,
});
export const setAriaLiveRegionContents = newContents => {
    console.log("contents!", newContents);
    return {
        type: "ARIA_LIVE_REGION:SET",
        payload: newContents,
    };
};



// WEBPACK FOOTER //
// ./src/actions/ui.js